export default class BallSwipeHandler extends Phaser.Sprite
{
    constructor(game, ball, targets)
    {
        super(game);

        this.hasReceivedDown = false;
        this.maxDistance = 400;
        this.targets = targets;
        this.ball = ball;

        this.ball.events.onInputDown.add(this.onInputDown, this);
        this.ball.inputEnabled = true;
        this.game.input.onUp.add(this.onInputUp, this);

        this.onSwipeCompleted = new Phaser.Signal();
    }

    onInputDown()
    {
        this.hasReceivedDown = true;
    }

    onInputUp()
    {
        if(this.hasReceivedDown && this.inputEnabled)
        {
            this.hasReceivedDown = false;

            var inputPosition = new Phaser.Point(this.game.input.x, this.game.input.y);
            var offsetBallPosition = new Phaser.Point(this.ball.position.x, this.game.height);

            var shortestDistance = Number.MAX_SAFE_INTEGER;
            var index = -1;

            for(let i = 0; i < this.targets.length; i++)
            {
                var distance = Math.abs(Phaser.Point.distance(inputPosition, this.targets[i].targetPosition));
                if(distance < shortestDistance)
                {
                    shortestDistance = distance;
                    index = i;
                }
            }

            if(shortestDistance < this.maxDistance)
            {
                this.onSwipeCompleted.dispatch(index);
            }
        }
    }

    destroy(children)
    {
        this.onSwipeCompleted.dispose();
        this.onSwipeCompleted = null;
        delete this.targets;
        delete this.ball;
        super.destroy(children);
    }
}
